<template>
  <v-text-field
    v-model="currentText"
    class="text-field"
    density="compact"
    variant="plain"
    hide-details
    :bg-color="bgColor"
    :type="inputType"
    :placeholder="placeholder"
    :disabled="!editing"
    :prefix="prefix"
    :suffix="suffix"
  />
</template>
<script>
export default {
  name: 'DisplayFieldTextField',
  props: {
    value: {
      type: [String, Number],
      default: undefined,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    prefix: {
      type: String,
      default: undefined,
    },
    suffix: {
      type: String,
      default: undefined,
    },
  },
  // This emit is functionally the same as 'input' but for the sake of removing test errors
  // It is referred to as update:modelValue here
  emits: ['update:modelValue'],
  computed: {
    bgColor() {
      return this.editing ? '#EBEBEB' : 'rgb(0,0,0,0)';
    },
    currentText: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('update:modelValue', newVal);
      },
    },
  },
};
</script>
<!--
The variables in :deep(text-field) are to hack Vuetify so the text-field is the right height:
Vuetify sets the height correctly except when the text-field is exactly one line high.
--v-input-control-height: The height Vuetify is trying to set for the text-field.
--clamp-toggle: 0 if the text-field is one line high, else 1.
--height-from-ctrl: 0 if text-field is one line high, else equal to --v-input-control-height.
--height-from-min: 0 if text-field is multiple lines high, else 15px (the height we want for one line).
-->
<style lang="scss" scoped>
  .text-field {
   & :deep(input)  {
    // styles copied from .display-field-text
    @extend .display-field-text;
    // other styles
    -webkit-mask-image: none !important;
    mask-image: none !important;
    padding: 3px;
    overflow: hidden;
    --height-from-ctrl: calc(max(0px, calc(var(--v-input-control-height) - 38px)) + (38 * var(--clamp-toggle)));
    --height-from-min: calc(((var(--clamp-toggle) - 1px) * -1) * 15);
    --clamp-toggle: clamp(0px, calc(var(--v-input-control-height) - 38px), 1px);
    min-height: 21.5px;
  }
  & :deep(.v-field) {
    border-radius: 2px;
    opacity: 1;
  }
  & :deep(.v-field--disabled) {
    pointer-events: all;
  }
  & :deep(.v-field__input) {
    cursor: text;
  }
  & :deep(.v-text-field__prefix) {
    @extend .display-field-text;
    min-height: 0;
    align-self: center;
    padding: 0;
    padding-left: 3px;
  }
  & :deep(.v-text-field__suffix) {
    @extend .display-field-text;
    align-self: center;
    min-height: 0;
    padding: 0;
    padding-right: 3px;
  }
}
</style>
